module.exports = __webpack_public_path__ + "static/media/floor_layer.dd828176.svg";